import Service from '@/services/modules/reports.service';

const afterSales = async ({commit}, _object) => {
    const response = Service.afterSales(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const contracts = async ({commit}, _object) => {
    const response = Service.contracts(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const commissionByProfilesDownloadInPdf = async ({commit}, _object) => {
    return Service.commissionByProfilesDownloadInPdf(_object);
};

const commissionSurplusPerInstallment = async ({commit}, _object) => {
    const response = Service.commissionSurplusPerInstallment(_object);

    response.then(function(_response) {
        commit('put', _response);
    });
    
    return response
}

const commissionSurplusPerInstallmentDownloadInPdf = async ({commit}, _object) => {
    return Service.commissionSurplusPerInstallmentDownloadInPdf(_object);
}

const commissionBilling = async ({commit}, _object) => {
    const response = Service.commissionBilling(_object);

    response.then(function(_response) {
        commit('put', _response);
    });

    return response
};

const commissionBillingInPdf = async ({commit}, _object) => {
    return Service.commissionBillingInPdf(_object);
}

const commissionContemplation = async ({commit}, _object) => {
    const response = Service.commissionContemplation(_object);

    response.then(function(_response) {
        commit('put', _response);
    });

    return response
};

const commissionContemplationInPdf = async ({commit}, _object) => {
    return Service.commissionContemplationInPdf(_object);
}

const analyticalCommissionByProfiles = async ({commit}, _object) => {
    const response = Service.analyticalCommissionByProfiles(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const analyticalCommissionByProfilesDownloadInPdf = async ({commit}, _object) => {
    return Service.analyticalCommissionByProfilesDownloadInPdf(_object);
};

const leadConversion = async ({commit}, _object) => {
    const response = Service.leadConversion(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};


const nonPaymentCancellation = async ({commit}, _object) => {
    const response = Service.nonPaymentCancellation(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};


const nonPaymentDelay = async ({commit}, _object) => {
    const response = Service.nonPaymentDelay(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const nonPaymentMontly = async ({commit}, _object) => {
    const response = Service.nonPaymentMontly(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const mediaConversion = async ({commit}, _object) => {
    const response = Service.mediaConversion(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const evaluations = async ({commit}, _object) => {
    const response = Service.evaluations(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const commissionByProfiles = async ({commit}, _object) => {
    const response = Service.commissionByProfiles(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const commissionOfProductionByProposalTypes = async ({commit}, _object) => {
    const response = Service.commissionOfProductionByProposalTypes(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const commissionOfProductionByProposalTypesDownloadInPdf = async ({commit}, _object) => {
    return Service.commissionOfProductionByProposalTypesDownloadInPdf(_object);
};

const commissionOfMonths = async ({commit}, _object) => {
    const response = Service.commissionOfMonths(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const commissionOfMonthsDownloadInPdf = async ({commit}, _object) => {
    return Service.commissionOfMonthsDownloadInPdf(_object);
};

const storeCommission = async({commit}, _object) => {
    const response = Service.storeCommission(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};
const storeCommissionDetails = async({commit}, _object) => {
    const response = Service.storeCommissionDetails(_object);

    response.then(function (_response) {
        commit('putDetail', _response);
    });

    return response;
};

const productionRating = async({commit}, _object) => {
    const response = Service.productionRating(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const resumeAnalyticalCommissionProfile = ({commit}, _object) => {
    commit('calculateAnalyticalCommissionProfile', _object)
};

const typeSalesByProfile = async({commit}, _object) => {
    const response = Service.typeSalesByProfile(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

const typeSalesByProfileInPdf = async({commit}, _object) => {
    const response = Service.typeSalesByProfileInPdf(_object);

    response.then(function (_response) {
        commit('put', _response);
    });

    return response;
};

export default {
    afterSales,
    contracts,
    commissionByProfilesDownloadInPdf,
    commissionSurplusPerInstallment,
    commissionSurplusPerInstallmentDownloadInPdf,
    commissionBilling,
    commissionBillingInPdf,
    commissionContemplation,
    commissionContemplationInPdf,
    analyticalCommissionByProfiles,
    analyticalCommissionByProfilesDownloadInPdf,
    commissionByProfiles,
    commissionOfProductionByProposalTypes,
    commissionOfProductionByProposalTypesDownloadInPdf,
    commissionOfMonths,
    commissionOfMonthsDownloadInPdf,
    evaluations,
    leadConversion,
    mediaConversion,
    productionRating,
    storeCommission,
    storeCommissionDetails,
    resumeAnalyticalCommissionProfile,
    nonPaymentMontly,
    nonPaymentDelay,
    nonPaymentCancellation,
    typeSalesByProfile,
    typeSalesByProfileInPdf
};
